import React, { Component } from 'react';
import { Popup } from 'devextreme-react';

import EmailPartial from './Email';
import SmsPartial from './Sms';
import BodyEnd from '../../_shared/BodyEnd';

import * as fn from '../../../../utilities/_functions';

import './_index.scss';

const COMMUNICATION_PARTIAL_POPUP_ID = '__communication-partial-popup';
const COMMUNICATION_PARTIAL_MODAL_GRID_WIDTH = 960;

export default class CommunicationPartialModal extends Component {
    constructor(props) {
        super(props);
        this.popupRef = React.createRef();
        this.state = {
            display: false,
            zIndex: null,
            renderRecenter: false,
            type: null,
        };
        this.handleSaved = this.handleSaved.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.renderContent = this.renderContent.bind(this);
    }

    show = (type) => {
        const zIndex = fn.getHighestZIndex() + 1;
        this.setState({ display: true, zIndex: zIndex, type: type });
    }

    close = () => {
        this.handleClose();
    }

    recenter = () => {
        if (this.popupRef && this.popupRef.current) {
            this.popupRef.current.instance.option('position', {
                my: 'center',
                at: 'center',
                of: window,
            })
        }
    }

    handleShown = event => {
        this.setState({ renderRecenter: true });
    }

    handleSaved = (event, result) => {
        if (this.props.onSaved) { this.props.onSaved(event, result); }
        this.setState({ display: false, zIndex: null, type: null, renderRecenter: false });
    }

    handleClose = event => {
        if (this.props.onClose) { this.props.onClose(); }
        this.setState({ display: false, zIndex: null, type: null, renderRecenter: false });
    }

    renderTitle = () => {
        return <div className='popup-title-draggable'></div>
    }

    renderContent = () => {
        const contentProps = {
            onSaved: this.handleSaved,
            onClose: this.handleClose
        };
        const { type } = this.state;

        if (type) {
            switch (type.toLowerCase()) {
                case 'email':
                    return <EmailPartial {...contentProps} />;

                case 'sms':
                    return <SmsPartial {...contentProps} />;

                default:
                    return;
            }
        }
    }

    render() {
        return <>
            <Popup
                ref={this.popupRef}
                wrapperAttr={{ id: COMMUNICATION_PARTIAL_POPUP_ID, class: 'dx-popup-communication-partial' }}
                animation={{
                    show: {
                        type: 'pop',
                        duration: 200,
                        from: { opacity: 0, scale: 0 },
                        to: { opacity: 1, scale: 1 }
                    },
                    hide: {
                        type: 'pop',
                        duration: 200,
                        from: { opacity: 1, scale: 1 },
                        to: { opacity: 0, scale: 0 }
                    }
                }}
                visible={this.state.display}
                shading={true}
                shadingColor="rgba(0, 0, 0, 0.2)"
                width={COMMUNICATION_PARTIAL_MODAL_GRID_WIDTH}
                height={'auto'}
                dragEnabled={true}
                dragOutsideBoundary={true}
                showTitle={true}
                titleRender={this.renderTitle}
                contentRender={this.renderContent}
                onShown={this.handleShown}
                onHiding={this.handleClose}
            />
            {
                this.state.renderRecenter ?
                    <BodyEnd>
                        <button
                            type='button'
                            className='dx-popup-recenter'
                            style={{ zIndex: fn.getHighestZIndex() }}
                            title='Re-center'
                            onClick={() => { this.recenter() }}
                        >
                            <i className='fal fa-arrows'></i>
                        </button>
                    </BodyEnd> : null
            }
        </>
    }
}